import { OptionsPanelInfoView, OptionsPanelView } from './options-panel.models';

export class SetView {
  static readonly type = '[OptionsPanelState] SetView';
  constructor(
    public readonly view: OptionsPanelView,
    public readonly withToggle: boolean = false,
  ) {}
}

export class SetInfoView {
  static readonly type = '[OptionsPanelState] SetInfoView';
  constructor(public readonly infoView: OptionsPanelInfoView) {}
}

export class SetPreviewVisible {
  static readonly type = '[OptionsPanelState] SetPreviewVisible';
  constructor(public readonly previewVisible: boolean) {}
}
